import React, { Suspense, lazy, useContext } from 'react'
import { Checkbox, Modal } from 'rsuite'
import AppContext from '../../context/AppContext'

const PDPANoticeContent = lazy(() => import('./PDPANoticeContent'))

export default function PDPANoticeModal({
  show,
  onHide,

  shouldRenderPdpaContent,
  acceptPDPA,
  setAcceptPDPA,
  saveButton,
  cancelButton,
}) {
  const { theme } = useContext(AppContext)
  const isDarkTheme = theme?.[0] === 'dark'

  return (
    <Modal
      className={`pdpa-modal${isDarkTheme ? ' pdpa-modal-dark' : ''}`}
      full={true}
     
      show={show}
      onHide={onHide}
      // dialogStyle={{width: 'min(960px, calc(100vw - 48px))',
      //         maxWidth: '960px',
      //         minWidth: '720px',
      //         margin: '24px auto',}}
          
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <p style={{ paddingTop: '0.5rem', color: isDarkTheme ? '#f3f7fa' : undefined }}>PDPA</p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          maxHeight:  'calc(100vh - 190px)',
          overflow: 'hidden auto',
          padding: 8,
          background: isDarkTheme ? 'linear-gradient(180deg, #10171d 0%, #0c1218 100%)' : undefined,
          color: isDarkTheme ? '#e5eef3' : undefined,
        }}
      >
        <div style={{ margin: '0 auto', width: '100%', maxWidth: '100%' }}>
          {shouldRenderPdpaContent ? (
            <Suspense fallback={<div style={{ padding: '24px 0' }}>กําลังโหลดรายละเอียด PDPA...</div>}>
              <PDPANoticeContent isNewTheme isDarkTheme={isDarkTheme} />
            </Suspense> 
          ) : (
            <div style={{ padding: '24px 0' }}>กําลังเตรียมรายละเอียด PDPA...</div>
          )}
          <Checkbox
            style={{ marginTop: 20, paddingBottom: 8, color: isDarkTheme ? '#d2dde6' : undefined }}
            checked={acceptPDPA}
            onChange={(_, check) => {
              setAcceptPDPA(check)
            }}
          >
            {'รับทราบ PDPA'}
          </Checkbox>
        </div>
      </Modal.Body>

      <Modal.Footer
        style={
            {
                background: isDarkTheme ? '#0f151b' : undefined,
                borderTop: `1px solid ${isDarkTheme ? '#22303b' : '#eef2f7'}`,
              }
        }
      >
        {saveButton}
        {cancelButton}
      </Modal.Footer>
    </Modal>
  )
}
